// extracted by mini-css-extract-plugin
export default {"root":"CarouselDesktop-module-root-tmpvb","leftPartEnterMatchInfo":"CarouselDesktop-module-leftPartEnterMatchInfo-OK7hW"};